// LabelControl.tsx
import { Control } from '../ControlRenderer';
import { Typography } from '@mui/material';
import { FormModeType } from '@/components/FormDataProvider';

interface LabelControl extends Control {
  fontSize: number;
}

interface LabelControlProps {
  control: Control;
  mode: FormModeType;
}

const LabelControl: React.FC<LabelControlProps> = ({ control, mode }) => {
  const labelStyle: React.CSSProperties = {
    fontSize: `${(control as LabelControl).fontSize}px`
  };

  switch (control.horizontalAlignment) {
    case 'left':
      labelStyle.textAlign = 'left';
      break;
    case 'center':
      labelStyle.textAlign = 'center';
      break;
    case 'right':
      labelStyle.textAlign = 'right';
      break;
    case 'stretch':
      labelStyle.width = '100%';
      break;
  }

  switch (control.verticalAlignment) {
    case 'top':
      labelStyle.verticalAlign = 'top';
      break;
    case 'middle':
      labelStyle.verticalAlign = 'middle';
      break;
    case 'bottom':
      labelStyle.verticalAlign = 'bottom';
      break;
    case 'stretch':
      labelStyle.height = '100%';
      break;
  }

  return (
    <>
    {mode !== 'design' ? (  
      <Typography className='eform-label' style={labelStyle}>{control.label}</Typography>
    ) : (
      <div style={{ position: 'relative' }}>
        <Typography className='eform-label' style={labelStyle}>{control.label}</Typography>
      </div>
    )}
    </>    
  );
};

export default LabelControl;
